import { render } from "./system_dashboard.vue?vue&type=template&id=341efe60&scoped=true"
import script from "./system_dashboard.vue?vue&type=script&lang=js"
export * from "./system_dashboard.vue?vue&type=script&lang=js"

import "./system_dashboard.vue?vue&type=style&index=0&id=341efe60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-341efe60"]])

export default __exports__